import indianStates from "../state/indianStates.json";

export type IndianStateOption = {
  state: string;
  code?: string;
  capital?: string;
  population?: string | number;
};

export const sortAlphabetically = <T>(
  items: T[],
  getValue: (item: T) => string,
) =>
  [...items].sort((a, b) =>
    getValue(a).localeCompare(getValue(b), "en", { sensitivity: "base" }),
  );

export const indianStateList = sortAlphabetically(
  indianStates as IndianStateOption[],
  (item) => item.state,
);

export const indianStateSelectOptions = indianStateList.map((item) => ({
  label: item.state,
  value: item.state,
}));
